type QueryValue = string | number | boolean;

/**
 * `path` with `query` appended as a query string. An entry that is undefined or null is left out,
 * so an optional parameter the caller did not set is not sent as the string "undefined". An array
 * is sent as its key repeated once per item, the form ASP.NET binds to a collection.
 */
export function withQuery(path: string, query?: Record<string, QueryValue | readonly QueryValue[] | null | undefined>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query ?? {})) {
    if (value === undefined || value === null) continue;
    for (const item of Array.isArray(value) ? value : [value]) params.append(key, String(item));
  }
  const encoded = params.toString();
  return encoded ? `${path}?${encoded}` : path;
}
